module.exports = __webpack_public_path__ + "img/touki-tqs-title.2e47df72.png";